
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface TagsFilterDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  availableTags: string[];
  selectedTags: string[];
  onToggleTag: (tag: string) => void;
  onClearAll: () => void;
  // Compatibility props
  showTagsFilter?: boolean;
  setShowTagsFilter?: (show: boolean) => void;
  toggleTag?: (tag: string) => void;
  setSelectedTags?: (tags: string[] | ((prev: string[]) => string[])) => void;
}

export function TagsFilterDialog({
  isOpen,
  onOpenChange,
  availableTags,
  selectedTags,
  onToggleTag,
  onClearAll,
  // Handle compatibility with previous prop pattern
  showTagsFilter,
  setShowTagsFilter,
  toggleTag,
  setSelectedTags,
}: TagsFilterDialogProps) {
  const { t } = useTranslation();
  
  // Use compatibility props if provided and main props are missing
  const dialogOpen = isOpen !== undefined ? isOpen : showTagsFilter;
  const handleOpenChange = onOpenChange || ((open: boolean) => {
    if (setShowTagsFilter) setShowTagsFilter(open);
  });
  
  const handleToggleTag = onToggleTag || toggleTag;
  const handleClearAll = onClearAll || (() => {
    if (setSelectedTags) setSelectedTags([]);
  });
  
  if (!handleToggleTag) return null;
  
  return (
    <Dialog open={dialogOpen} onOpenChange={handleOpenChange}>
      <DialogContent className='sm:max-w-md'>
        <DialogHeader>
          <DialogTitle>Filter by Dietary Preferences</DialogTitle>
        </DialogHeader>
        <div className='grid grid-cols-2 gap-2 my-4'>
          {availableTags.map((tag) => (
            <div key={tag} className='flex items-center space-x-2'>
              <Button
                variant={selectedTags.includes(tag) ? 'default' : 'outline'}
                className='w-full justify-start'
                onClick={() => handleToggleTag(tag)}>
                {selectedTags.includes(tag) && '✓ '}
                {tag}
              </Button>
            </div>
          ))}
        </div>
        <div className='flex justify-between'>
          <Button variant='ghost' onClick={handleClearAll}>
            Clear All
          </Button>
          <Button onClick={() => handleOpenChange(false)}>
            Apply Filters
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
